/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CarEventsFeaturesEnum {
    DESCRIPTION = 'description',
    LICENSE_PLATE = 'license_plate',
    SPECIAL_VEHICLE_TYPE = 'special_vehicle_type',
    CATEGORY = 'category',
    WEIGHT_TYPE = 'weight_type',
    ORIENTATION = 'orientation',
}